<div class="vtz-main-wrapper">
    <div class="vtz-main-container vtz-main-container--home">
      <div class="vtz-title-section vtz-title-section--blue">
        <app-header></app-header>
      </div>
      <main>
        <div class="vtz-no-print">
          <app-progress-bar [routeName]="routeName"></app-progress-bar>
        </div>
        <h1 id="main-title" class="vtz-h1" i18n>Ballot Return Options</h1>
        <h2 class="vtz-text vtz-text--wide vtz-text--center" i18n>
          How do you want to return your ballot?
        </h2>
        <div id="button-group" class="button-group">
  
          <div class="vtz-spacer-10"></div>
  
        </div>
        <div class="wizard-cards">
          <mat-card class="wizard-card">
            <img mat-card-image src="assets/images/www.jpeg"   alt="submit  ballot electronically" >
            <mat-card-content>
              <p>
                You will mark your ballot online, review your selections and submit your ballot electronically.  A ballot receipt will be sent to you via email.
              </p>
            </mat-card-content>
            <mat-card-actions>
              <button id="submit-button" i18n class="button-primary" (click)="toBallot('ELECTRONIC')">
                ONLINE
              </button>
            </mat-card-actions>
          </mat-card>
    
          <mat-card class="wizard-card">
            <img mat-card-image src="assets/images/pandm.jpeg" alt="print and mail"  >
            <mat-card-content>
              <p>
                You can mark the ballot online or continue to print a blank ballot to mark manually.  The printing kit contains the instructions to prepare and mail your ballot.  You must sign the affidavit on the inner envelope.
              </p>
            </mat-card-content>
            <mat-card-actions>
              <button id="submit-button" i18n class="button-primary" (click)="toBallot('PRINT')">
                PRINT AND MAIL
              </button>
            </mat-card-actions>
          </mat-card>
  
        </div>
  
  
      </main>
    </div>
  </div>
  <app-back-button-confirmation-modal>
  </app-back-button-confirmation-modal>